module.exports = __webpack_public_path__ + "img/icn_brand3.b29920bc.svg";